<script type="text/javascript">
    import { defineAsyncComponent } from 'vue';
    
    export default {
        MultiFileInput: defineAsyncComponent(() => import('@/components/Form/MultiFileInput/MultiFileInput.vue')),
    }
</script>